export const appConstants = {
	redirectQueryParamName: "returnTo",
};

export const PAGINATION_DEFAULT_PAGE_SIZE = 100;

export const REGULAR_ASSIGNMENT_STATE_IDS: Readonly<Record<string, number>> = {
	suggested: 1,
	"suggestion-rejected": 2,
	"suggestion-accepted": 3,
	selected: 4,
	proposed: 5,
	"proposal-accepted": 6,
	"proposal-declined": 7,
	withdrawn: 8,
	confirmed: 9,
};

export const REGULAR_BLOCKING_ASSIGNMENT_STATE_IDS: ReadonlySet<number> = new Set([
	REGULAR_ASSIGNMENT_STATE_IDS.suggested,
	REGULAR_ASSIGNMENT_STATE_IDS["suggestion-accepted"],
	REGULAR_ASSIGNMENT_STATE_IDS.selected,
	REGULAR_ASSIGNMENT_STATE_IDS.proposed,
	REGULAR_ASSIGNMENT_STATE_IDS["proposal-accepted"],
	REGULAR_ASSIGNMENT_STATE_IDS.confirmed,
]);
